import { SAFE_VALUES } from '@/base/constants/SafeValues'
import { createStorageManager } from './storage-manager-factory'

export const SESSION_STORAGE_KEYS = Object.freeze({
  initialReferrer: 'initialReferrer',
  lastSessionExpiredShown: 'lastSessionExpiredShown',
  traceSpikeHighlighted: 'traceSpikeHighlighted',
  lastChunkRefresh: 'lastChunkRefresh',
  forwardTo: 'forwardTo',
  platform: 'platform',
  globalSearchCountryCode: 'globalSearchCountryCode',
  globalSearchCountryCodes: 'globalSearchCountryCodes',
  globalSearchStore: 'globalSearchStore',
  globalSearchIntegratedToggle: 'globalSearchIntegratedToggle',
  organicDownloadSelected: 'organicDownloadSelected',
  showCompetitorsOnKwHistory: 'showCompetitorsOnKwHistory',
  kwHistoryStartDate: 'kwHistoryStartDate',
  kwHistoryEndDate: 'kwHistoryEndDate',
  currentPaymentState: 'currentPaymentState',
  competitionAnalysisStarred: 'competitionAnalysisStarred',
  rankingHistoryStarred: 'rankingHistoryStarred',
})

const sessionStorageManager = createStorageManager(sessionStorage, SESSION_STORAGE_KEYS, {
  prefix: 'ma_',
  placeholderData: {
    lastSessionExpiredShown: 0,
    rankingHistoryStarred: {},
    competitionAnalysisStarred: {},
    organicDownloadSelected: {},
    showCompetitorsOnKwHistory: true,
    globalSearchCountryCode: SAFE_VALUES.countryCode,
    globalSearchCountryCodes: [],
    globalSearchStore: 'all',
    globalSearchIntegratedToggle: false,
  },
})

export { sessionStorageManager }
